import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientHeadController_SaveStatus_Input_Status,
  useLegalClientLegalHeadSaveStatusMutation,
} from 'api/generated/graphql';
import { parseLegalClientLegalHeadEntity, useError } from 'api/helpers';

interface Props {
  versionNumber: number;
  reason: string;
}

export const useLegalClientLegalHeadDearchive = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientLegalHeadSaveStatusMutation();

  const error = useError(apolloError);

  return {
    legalClientLegalHead: data?.saveStatus
      ? parseLegalClientLegalHeadEntity(data.saveStatus)
      : undefined,
    loading,
    error,
    dearchive: useCallback(
      async (id: string, { reason, versionNumber }: Props) => {
        const res = await handle({
          variables: {
            id,
            input: {
              reason,
              versionNumber,
              status:
                MutationInput_LegalClientHeadController_SaveStatus_Input_Status.Active,
            },
          },
        });
        return res.data?.saveStatus
          ? parseLegalClientLegalHeadEntity(res.data?.saveStatus)
          : undefined;
      },
      [handle]
    ),
  };
};
